import { render, staticRenderFns } from "./fccCidadesDeProvasImportadas.vue?vue&type=template&id=1b341678"
import script from "./fccCidadesDeProvasImportadas.vue?vue&type=script&lang=js"
export * from "./fccCidadesDeProvasImportadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports